var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPopoverArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 13,
    viewBox: "0 0 47 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.9981C1.71249 12.9981 3.42448 13.0066 5.13697 12.9881C6.77598 12.9701 8.61044 12.9445 10.2055 12.343C11.9284 11.693 13.0691 10.5565 14.2168 9.21897C15.043 8.25695 16.666 6.20441 17.4563 5.21339C18.1031 4.40087 19.3692 2.79483 20.0605 2.01782C20.9308 1.0403 22.0064 0.00127411 23.5005 0.00127411C24.9946 0.00127411 26.0697 1.0403 26.9395 2.01682C27.6308 2.79333 28.8969 4.40037 29.5442 5.21239C30.3335 6.20341 31.9565 8.25595 32.7832 9.21797C33.9329 10.5555 35.0716 11.692 36.794 12.342C38.3896 12.942 40.2245 12.9691 41.8625 12.9871C43.5755 13.0056 45.2875 12.9971 47 12.9971",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverArrow);
export default __webpack_public_path__ + "static/media/popover_arrow.2f1f93972c0d574765273ccce46b33a1.svg";
export { ForwardRef as ReactComponent };